import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import JobDashboardAlertsBlock from "./JobDashboardAlertsBlock";
import JobDashboardApplicationsBlock from "./JobDashboardApplicationsBlock";
import JobDashboardSummaryBlock from "./JobDashboardSummaryBlock";
import JobDashboardCommissionBlock from "./JobDashboardCommissionBlock";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import useTranslationJobDashboard from "../useTranslationJobDashboard";
import Alert from "react-bootstrap/Alert";
import JobStatistics from "./JobStatistics";
import "./JobDashboardBlock.scss";
import JobStatusEnum from "../../jobs/JobStatusEnum";

function JobDashboardBlock(props) {
  const { job } = props;

  const { t, loading: tLoading } = useTranslationJobDashboard();
  useShowLoader(tLoading, "ApplicationPreview");

  const supportEmail =  process.env.REACT_APP_SUPPORT_EMAIL;
  const emailLinkComponent = <a href={"mailto:" + supportEmail}>{supportEmail}</a>
  const pendingAlertMsg = t("job-dashboard:job_dashboard_approval_alert_text", {
    postProcess: "reactPostprocessor",
    emailLink: emailLinkComponent
  });

  return (
    <div className="JobDashboardBlock">
      <Row>
        <Col>
          <JobDashboardSummaryBlock job={job} />
        </Col>
      </Row>
      {job.status === JobStatusEnum.PENDING && (
        <Row>
          <Col>
            <Alert variant={"danger"}>{pendingAlertMsg}</Alert>
          </Col>
        </Row>
      )}
      <Row className={"blockContainer"}>
        <Col className="blockContainerApplication">
          <div className="widget-block">
            <JobDashboardApplicationsBlock job={job} />
          </div>
        </Col>
        <Col className="blockContainerCommission ">
          <div className="widget-block">
            <JobDashboardCommissionBlock job={job} />
          </div>
        </Col>
        <Col className="blockContainerStatistics ">
          <div className="widget-block">
            <JobStatistics job={job} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <JobDashboardAlertsBlock job={job} />
        </Col>
      </Row>
    </div>
  );
}

export default JobDashboardBlock;
